import React, { FC, useEffect, useState } from "react"
import Carousel from "nuka-carousel"
import ReactPlayer from 'react-player'
import Cookies from 'js-cookie'
import Loading from '../Loading/Loading'
import OptionalCookieMessage from '../OptionalCookieMessage/OptionalCookieMessage'

type props = {
    apiUrl: string;
    showThumbs: boolean;
}

const SlidingGallery: FC<props> = ({apiUrl, showThumbs = false}) => {

    const [GalleryItems, setGalleryItems] = useState([])
    const [LoadingState, setLoading] = useState(true)
    const [PlayingVideo, setPlayingVideo] = useState("")
    const [cookiesEnabled, setCookiesEnabled] = useState(false)
    
    const getData = () => {
        fetch(apiUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' } })
            .then((res) => res.json())
            .then((res) => {
                setGalleryItems(res)
                setLoading(false)
            })
    }

    //Same as componentDidMount (note array on end)
    useEffect(() => {
        console.log("Getting gallery data")
        setCookiesEnabled(Cookies.get("optoma_cookie_preference") === 'true')
        getData()
        
    }, [])

    return LoadingState ? (
        <Loading loadingtext="" />
    ) : (
        <div className="sliding-gallery-container">
            <Carousel className="sliding-gallery" wrapAround={false} beforeSlide={() => setPlayingVideo("")}>
                {GalleryItems.map(x => {
                    if(!x.video)
                    {
                        return <img src={x.original} key={x.original} />
                    } else {
                        
                        if(cookiesEnabled) {
                            return <ReactPlayer
                                url={x.original}
                                onPlay={() => setPlayingVideo(x.original)}
                                onPause={() => setPlayingVideo("")}
                                playing={PlayingVideo == x.original}
                                className="carousel-video"
                                volume={1}
                                muted={PlayingVideo != x.original}
                                width="auto" height="auto"
                                key={x.original}
                            />
                        }
                        else {
                            return (
                                <OptionalCookieMessage />
                            )
                        }
                    }
                    
                })}
            </Carousel>
        </div>
    )
}

export default SlidingGallery